import React from 'react';
import OptImage from '../utils/OptImage';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Priya Sharma",
      quote: "The quality of care and attention to detail here is unmatched. Every step of my treatment was handled with utmost professionalism and compassion."
    },
    {
      id: 2,
      name: "Vikram Patel",
      quote: "Dr. Deepika Sinha's expertise is evident in every interaction. The modern facilities and personalized approach made all the difference in my journey."
    },
    {
      id: 3,
      name: "Kavita Reddy",
      quote: "My transformation has been incredible thanks to Dr. Deepika's skillful hands. The results look completely natural and have boosted my confidence tremendously."
    },
    {
      id: 4,
      name: "Arjun Mehta",
      quote: "From advanced technology to caring staff, everything about this clinic reflects excellence. I couldn't have asked for better treatment anywhere else."
    },
    {
      id: 5,
      name: "Deepika Nair",
      quote: "The comprehensive care I received from initial consultation through follow-up was exceptional. Dr. Deepika and her team made me feel valued and supported."
    },
    {
      id: 6,
      name: "Rajesh Kumar",
      quote: "This clinic sets the gold standard for aesthetic treatments in Bhopal. Dr. Deepika Sinha's dedication to patient satisfaction and excellent outcomes is remarkable."
    }
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="container">
        <div className="testimonials-header">
          <h1 className="section-title">Patient Testimonials & Reviews</h1>
          <h2 className="section-subtitle">What People Say-</h2>
          <p className="testimonials-intro">
            Dr. Deepika Sinha's reputation for excellence speaks for itself. Read about our patients' experiences.
          </p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map(testimonial => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-icon">
                <OptImage src="quote-icon_sq6iae" alt="Quote icon for testimonial" />
              </div>
              <div className="testimonial-content">
                <p className="testimonial-quote">"{testimonial.quote}"</p>
                <div className="testimonial-rating">
                  <i className="fa fa-star" aria-label="star"></i>
                  <i className="fa fa-star" aria-label="star"></i>
                  <i className="fa fa-star" aria-label="star"></i>
                  <i className="fa fa-star" aria-label="star"></i>
                  <i className="fa fa-star" aria-label="star"></i>
                </div>
                <h4 className="testimonial-name">{testimonial.name}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;